<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="menu"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import role from "../../../router/index";
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      permission_routes: [],
      productType: localStorage.getItem("productType")
    };
  },
  computed: {
    ...mapGetters([
      // 'permission_routes',
      "sidebar"
    ]),
    ...mapState({
      isHidden: state => state.user.isHidden
    }),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  watch: {
    // backdoor
    isHidden(val) {
      if (val) {
        this.permission_routes.forEach(item => {
          if (item.meta && item.meta.isHidden) {
            item.hidden = true;
          }
        });
      }
    }
  },
  mounted() {
    // backdoor
    this.permission_routes = role.options.routes;
    if (this.isHidden) {
      this.permission_routes.forEach(item => {
        if (item.meta && item.meta.isHidden) {
          item.hidden = true;
        }
      });
    }

    const taxType = localStorage.getItem("taxType");
    if (taxType === "1") {
      this.permission_routes.forEach(item => {
        if (item.path && item.path === "/zzMerchant") {
          item.hidden = true;
        }
      });
    }
  },
  methods: {
    collapse() {
      this.$store.state.user.roles.map(item => {
        if (item.children && item.children.length > 1) {
          this.$refs.menu.close(item.path);
        }
      });
    }
  }
};
</script>
